import { forwardRef } from "react";

import HotelActivity from "./HotelActivity";
import HotelDetails from "./HotelDetails";
import HotelIcons from "./HotelIcons";
import HotelLocation from "./HotelLocation";
import HotelName from "./HotelName";
import HotelPricing from "./HotelPricing";
import HotelSlider from "./HotelSlider";

const HotelCard = forwardRef(function HotelCard(
	{
		children,
		onClick = () => { },
		className = "",
	},
	ref
) {
	return (
		<div
			ref={ref}
			onClick={onClick}
			className={`bg-white rounded-lg shadow-lg cursor-pointer overflow-hidden flex flex-col min-h-[480px] max-h-[520px] relative ${className}`}
		>
			{children}
		</div>
	);
});

export default HotelCard;

HotelCard.Slider = HotelSlider;
HotelCard.HotelName = HotelName;
HotelCard.Location = HotelLocation;
HotelCard.Icons = HotelIcons;
HotelCard.Activity = HotelActivity;
HotelCard.Details = HotelDetails;
HotelCard.Pricing = HotelPricing;
